import React from 'react';
import _ from 'lodash';
import styled from 'styled-components';

import terpeneIcons from './terpene-icon-map';

const TerpeneIcon = ({ name }) => {
  const slug = _.kebabCase(name);

  // Grab the appropriate icon based on the slug-ified terp name
  const Icon = terpeneIcons[slug]?.icon || '';
  const width = terpeneIcons[slug]?.width;

  return (
    Icon && (
      <IconWrap>
        <Icon width={width} />
      </IconWrap>
    )
  );
};

export default TerpeneIcon;

const IconWrap = styled.div`
  display: inline-flex;
  justify-content: flex-end;
  align-items: flex-start;
  padding-top: 2px;
  min-width: 30px;
  margin-right: 10px;
`;
